import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Skice",
  "description": "",
  "published": "2006-06-07T00:00:00.000Z",
  "redirect_from": ["/blog/skice/swizec/407"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Danes je za storiti nekaj oznanitev... je to sploh beseda... nobena od le-teh ni velicastna vendar tudi nobena ni nevelicastna, torej naj se oznanjanje kar pricne.`}</p>
    <ol>
      <li parentName="ol">{`Druga epizoda stripa Cthulhu je bila finalizirana kar se tice scenarija in bo najverjetneje koncana in nalozena do konca tedna, ce seveda ne bosta delo inu sola pojedla prevec tako zelo potrebnega casa, ki je potreben za izdelavo epizode. Nacrtovano je bilo, da bi danes pokazal skico osebka, ki bo nastopal v tej epizodi vendar do tega nekako ni prislo.`}</li>
      <li parentName="ol">{`Skupek direktorjev te strani... heh zanimiva misel... se je odlocil, da se bodo zacele delati vsakodnevne skice, ki se bodo po srecnem naklucju znasle na tej strani v taki ali drugacni obliki. Najverjetneje so bo ustvarjal thumbnail, ki bo dnevno osvezen pocival v kakem od stranskih stolpcev. Danes dobite prvo, potem pa se bodo dnevne osvezitve zacele, ko se pac bodo.`}</li>
    </ol>
    <p>{`Za konec pa si se pojdite pogledat `}<a parentName="p" {...{
        "href": "http://www.escapistmagazine.com/issue/48"
      }}>{`Blizzardovo skrivno omako.`}</a></p>
    <p><a parentName="p" {...{
        "href": "/includes/editor_upload/Image/sketches/kscan_0129.png"
      }}><img parentName="a" {...{
          "src": "/includes/editor_upload/Image/sketches/kscan_0129.png",
          "alt": null
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      